(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-edit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-edit-grid')) {
  customElements.define('product-edit-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.motion !== 'true' || !this.closest('.es-premium') || !('IntersectionObserver' in window)) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = new Set();
      this.onPreference = () => {
        if (this.motion.matches) {
          this.observer?.disconnect();
          this.animations.forEach(animation => animation.cancel());
          this.animations.clear();
        }
      };
      this.motion.addEventListener('change', this.onPreference);
      if (this.motion.matches) return;
      this.observer = new IntersectionObserver(entries => {
        entries.forEach((entry, index) => {
          if (!entry.isIntersecting) return;
          this.observer.unobserve(entry.target);
          if (this.motion.matches) return;
          const animation = entry.target.animate([
            {opacity:0.65,transform:'translateY(16px)'},
            {opacity:1,transform:'translateY(0)'}
          ], {duration:500,delay:(index % 3) * 50,easing:'cubic-bezier(.23,1,.32,1)'});
          this.animations.add(animation);
          animation.finished.then(() => this.animations.delete(animation), () => this.animations.delete(animation));
        });
      }, {threshold:0.12});
      this.querySelectorAll('.es-product').forEach(card => this.observer.observe(card));
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.onPreference);
      this.animations?.forEach(animation => animation.cancel());
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
